export default __webpack_public_path__ + "static/media/Letter J.b7e62f5d.mov";